import { useState, useEffect } from "react";

export default function GyroActivatorIOS({ onActivate }) {
  const [needsPermission, setNeedsPermission] = useState(false);

  useEffect(() => {
    // Vérifie si on est sur iOS Safari
    const isiOS = typeof DeviceOrientationEvent !== "undefined" &&
      typeof DeviceOrientationEvent.requestPermission === "function";

    if (isiOS) {
      setNeedsPermission(true);
    }
  }, []);

  const handleClick = async () => {
    try {
      const res = await DeviceOrientationEvent.requestPermission();
      if (res === "granted") {
        setNeedsPermission(false);
        onActivate?.(); 
      }
    } catch (err) {
      console.warn("Permission gyroscope refusée :", err);
    }
  };

  if (!needsPermission) return null;

  return (
    <>
    <div
      onClick={handleClick}
      style={{
        position: "fixed",
        inset: 0,
        background: "transparent", // invisible
        zIndex: 9999,
      }}
    />
    </>
  );
}
